import { useState } from 'react';

import CreateTrialTeamModal from '@/components/CreateTrialTeamModal';
import { NotLoggedInBadge } from '@/components/NotLoggedInBadge';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { useUsers } from '@/hooks/useUsers';

export function NewTeamDialog({ onClose }: { onClose: () => void }) {
  const [searchInput, setSearchInput] = useState('');
  const [search, setSearch] = useState('');
  const [ownerEmail, setOwnerEmail] = useState<string | null>(null);
  const { data: users } = useUsers({
    page: 1,
    limit: 8,
    search: search || undefined,
  });

  if (ownerEmail) {
    return (
      <CreateTrialTeamModal isOpen onClose={onClose} ownerEmail={ownerEmail} />
    );
  }

  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>New team</DialogTitle>
          <DialogDescription>
            Who owns the team? If they don't have a Littlebird account yet, one
            is created for them. Everyone else can be invited by email on the
            next step.
          </DialogDescription>
        </DialogHeader>
        <form
          className="flex gap-2"
          onSubmit={(e) => {
            e.preventDefault();
            setSearch(searchInput.trim());
          }}
        >
          <Input
            autoFocus
            placeholder="Search by owner email"
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
          />
          <Button type="submit" variant="outline">
            Search
          </Button>
        </form>
        {search && (
          <div className="divide-y rounded-md border">
            {users?.users.length === 0 &&
              (search.includes('@') ? (
                <button
                  type="button"
                  className="block w-full px-3 py-2 text-left text-sm hover:bg-muted"
                  onClick={() => setOwnerEmail(search)}
                >
                  No account yet. Create one for{' '}
                  <span className="font-medium">{search}</span> and make them
                  the owner
                </button>
              ) : (
                <p className="p-3 text-sm text-muted-foreground">
                  No account matches. Enter the owner's full email to create
                  one.
                </p>
              ))}
            {users?.users.map((user) => (
              <button
                key={user.id}
                type="button"
                className="flex w-full items-center gap-2 px-3 py-2 text-left text-sm hover:bg-muted"
                onClick={() => setOwnerEmail(user.email)}
              >
                {user.email}
                {user.name && (
                  <span className="text-muted-foreground">{user.name}</span>
                )}
                {!user.has_logged_in && <NotLoggedInBadge />}
              </button>
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
